export enum layoutConstants {
    BASIC = 'basic',
    BASIC_LEFT = 'basic-left',
    VERTICAL = 'vertical',
    VERTICAL_LEFT = 'vertical-left',
    VERTICAL_TOP = 'vertical-top',
}

export enum itemType {
    STRUCTURE_ELEMENT= 'structureElement',
    RESOURCE= 'resource',
}

export enum stimulusPositions {
    NO = 'no',
    LEFT = 'left',
    TOP = 'top',
}

export enum allowedAudioFilesCount {
    QUESTION = 1,
    OTHER_TYPES = 2,
}

export enum allowedPDFFilesCount {
    SECTION = 10
}
